import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints'

const { endpoints:{
  dashNotifications:{
    dashNotifications,
    notificationsHasNew,
    notificationsRead
  }
} } = config

const getNotifications = (filters) => axios.post(dashNotifications, filters, { headers: getHeaders(true) })

/**
 * 
 * @param {object} data 
 * @param {string} data.notificationId
 * @param {boolean} data.isRead
 */
const markRead = (data) => axios.post(notificationsRead, data, { headers: getHeaders(true) })

const getInformationForNotification = () => axios.get(notificationsHasNew, { headers: getHeaders(true) })

export default {
  getNotifications,
  markRead,
  getInformationForNotification
}